export default "__VITE_ASSET__BnJFmR$e__"